<template>
  <b-modal
    id="modal-renouvellement-list"
    size="xl"
    title="Renouvellement(s)"
    title-class="modal__title modal__title--edit"
  >
  <RenouvellementList />
  <template #footer="{ cancel }">
    <b-button
      variant="default"
      id="back-renouvellement-list"
      title="Revenir sur le panneau d'administration"
      @click="cancel()"
    >
      Retour
      <b-tooltip target="#back-renouvellement-list">
        Revenir sur le panneau d'administration
      </b-tooltip>
    </b-button>
  </template>
  </b-modal>
</template>
<script setup>
import {BModal, BButton, BTooltip} from "bootstrap-vue-next";
import RenouvellementList from "@/components/ParcProfileParcCardRenouvellementList.vue";

</script>
